import request from "../request";

export const createWorkedExample = (curriculumId, drId, data) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics/${drId}/worked-examples`, data).then((res) => res);

export const updateWorkedExample = (curriculumId, drId, id, data) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${drId}/worked-examples/${id}`, data).then((res) => res);

export const deleteWorkedExample = (curriculumId, drId, id) =>
  request.delete(`/assessment/${curriculumId}/developmental-rubrics/${drId}/worked-examples/${id}`).then((res) => res);
